var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html } from 'lit';
import { state } from 'lit/decorators.js';
import { SdsTagBase } from '../_sds-tag-base.lit';
import styles from './sds-tag-dropdown.lit.scss';
import { sdsCustomElement } from '../../utilities/custom-components';
/**
 * A tag component with dropdown functionality.
 *
 * This component extends the base tag functionality to provide a tag
 * that can be clicked to reveal a dropdown menu with additional options.
 *
 * @tag sds-tag-dropdown
 *
 * @fires click - Fired when the tag dropdown is clicked
 */
let SdsTagDropdown = (() => {
    var _SdsTagDropdown__opened_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-tag-dropdown')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = SdsTagBase;
    let __opened_decorators;
    let __opened_initializers = [];
    let __opened_extraInitializers = [];
    var SdsTagDropdown = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            _SdsTagDropdown__opened_accessor_storage.set(this, __runInitializers(this, __opened_initializers, false));
            /**
             * Event handler for document clicks to close the dropdown when clicking outside.
             *
             * @param event - The mouse event
             * @private
             */
            this.documentClickHandler = (__runInitializers(this, __opened_extraInitializers), (event) => {
                if (event.target !== this && this._opened) {
                    this._opened = false;
                }
            });
        }
        /**
         * Internal state tracking whether the dropdown is open.
         *
         * @internal
         * @default false
         */
        get _opened() { return __classPrivateFieldGet(this, _SdsTagDropdown__opened_accessor_storage, "f"); }
        set _opened(value) { __classPrivateFieldSet(this, _SdsTagDropdown__opened_accessor_storage, value, "f"); }
        /**
         * Renders the tag dropdown component.
         *
         * @returns A template result containing the rendered tag dropdown
         */
        render() {
            return html ` ${this.renderTag()} `;
        }
        connectedCallback() {
            super.connectedCallback();
            document.addEventListener('click', this.documentClickHandler);
        }
        disconnectedCallback() {
            super.disconnectedCallback();
            document.removeEventListener('click', this.documentClickHandler);
        }
        /**
         * Handles click events on the tag dropdown.
         * Toggles the opened state of the dropdown.
         */
        handleClick() {
            this._opened = !this._opened;
        }
        /**
         * Renders the tag dropdown element with its content and styling.
         *
         * @returns A template result containing the tag dropdown element
         * @private
         */
        renderTag() {
            return html `
            <div
                class="${this.getClasses()} sds-tag-dropdown"
                @click="${() => this.handleClick()}"
                @mousedown="${() => this.handleMouseDown()}"
                @focus="${() => this.handleFocus()}"
                @blur="${() => this.handleBlur()}"
                @keydown="${(e) => this.handleKeyDown(e)}"
                .disabled="${this.disabled}"
                tabindex="${this.clickable || this.selectable ? '0' : '-1'}"
            >
                <div class="sds-tag-dropdown__name">
                    <sds-clipped-text
                        basic
                        text="${this.name}"
                        lines="${this.lines}"
                    ></sds-clipped-text>
                </div>
                ${this.renderArrowIcon()}
            </div>
        `;
        }
        /**
         * Renders the arrow icon for the dropdown.
         * Changes direction based on whether the dropdown is open or closed.
         *
         * @returns A template result containing the arrow icon
         * @private
         */
        renderArrowIcon() {
            return html ` <sds-icon
            size="${this._iconSize}"
            name="${this._opened ? 'arrow_up_small' : 'arrow_down_small'}"
        ></sds-icon>`;
        }
    };
    _SdsTagDropdown__opened_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsTagDropdown");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        __opened_decorators = [state()];
        __esDecorate(_classThis, null, __opened_decorators, { kind: "accessor", name: "_opened", static: false, private: false, access: { has: obj => "_opened" in obj, get: obj => obj._opened, set: (obj, value) => { obj._opened = value; } }, metadata: _metadata }, __opened_initializers, __opened_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsTagDropdown = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.styles = styles;
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsTagDropdown = _classThis;
})();
export { SdsTagDropdown };
